<div class="login-container w-100">
  <ng-container *ngIf="!this.tokenUnlockService.tokenBlockError; else tokenBlocked">
    <form [formGroup]="loginForm">
      <div class="col-12">
        <label for="user" class="form-label">{{'Usuario' | translate}}</label>
        <input formControlName="username" type="text" class="form-control" id="user"  [ngClass]="showLoginError ? 'error-class':''">
      </div>
      <div class="mb-3 col-12 mt-2">
        <label for="password" class="form-label">{{'Contrasena' | translate}}</label>
        <p-password formControlName="password" class="w-100 " id="password"
                    [feedback]="false" [toggleMask]="true"
                    [inputStyleClass]="showLoginError ? 'error-class form-control':'form-control'" ></p-password>
        <small *ngIf="showLoginError" class="p-error block">
          <span *ngIf="this.messageError != undefined && this.messageError != null ; else wrongPass">
            {{this.messageError | translate}}.
          </span>
          <ng-template #wrongPass>
            <span >
              {{'La contrasena es incorrecta'|translate}}. {{'Intenta nuevamente' | translate}}.
            </span>
          </ng-template>
        </small>

      </div>
      <div class="actions-container w-100">
        <button type="button" (click)="login()" class="btn-primary login-btn text-truncate overflow-hidden text-nowrap" [disabled]="!loginForm.valid || loading">
          <span *ngIf="!this.loading">{{'Iniciar sesion' | translate}}</span>
          <div *ngIf="this.loading" class="loading">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{'Iniciando'|translate}}...
          </div>
        </button>
        <div class="password-actions">
          <div class="forget-password" (click)="showFormRestorePassword()">
            ¿{{'Olvidaste tu contrasena' | translate}}?
          </div>
          <div class="new-user-container" (click)="goToRegisterUsers()">
            {{'Registro de usuario y token' | translate}}
          </div>
        </div>
      </div>
    </form>

    <lib-wso2form #wso2form [usernameWso2]="usernameWso2" [passwordWso2]="passwordWso2" [samlRequest]="samlRequest"></lib-wso2form>
  </ng-container>
  <ng-template #tokenBlocked>
    <div *ngIf="this.tokenUnlockService.tokenBlockError" class="info-container">
      <lib-access-disabled></lib-access-disabled>
    </div>
  </ng-template>
</div>
